<div *ngIf="isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div class="panel border-[#e0e6ed] px-5 pb-1.5 dark:border-[#1b2e4b]">
  <h1 class="mb-5 text-lg font-bold" *ngIf="!apiKey">{{ "users_page.users_without_instance" | translate }}</h1>
  <div class="datatable invoice-table" *ngIf="cols && items">
    <ng-datatable
      #datatable
      [rows]="items"
      [columns]="cols"
      [stickyHeader]="true"
      [height]="'470px'"
      [sortable]="false"
      [pagination]="false"
      [isServerMode]="true"
      [totalRows]="items.length"
      skin="whitespace-nowrap bh-table-hover"
      [paginationInfo]="'paginationInfoLabel' | translate"
    >
      <ng-template slot="tAId" let-value="data">
        <div class="flex items-center font-semibold">
          <span *ngIf="value.taId === 1" class="inline-block px-3 py-1 text-sm font-medium text-white bg-blue-600 rounded-md mr-2">Main</span>
          {{ value.taId ?? "/" }}
        </div>
      </ng-template>
      <ng-template slot="zephyrId" let-value="data">
        <div class="flex items-center font-semibold">{{ value.zephyrId ?? "/" }}</div>
      </ng-template>
      <ng-template slot="actions" let-value="data">
        <div class="flex w-max items-center justify-between">
          <div hlMenu class="dropdown">
            <a hlMenuButton href="javascript:;">
              <icon-horizontal-dots class="rotate-90 opacity-70" />
            </a>
            <div #dropdownPlaceholder *hlMenuItems>
              <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                <li>
                  <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openDeleteModal(value.email, value.apiKey)">
                    <icon-trash-lines class="shrink-0 ltr:mr-2 rtl:ml-2" />
                    {{ "delete_quick_label" | translate }}
                  </a>
                </li>
              </app-message-portal>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-datatable>
  </div>
</div>
